// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"618de6d5","213":"c117d5ee","616":"ac4f1180","667":"550297c4"}[chunkId] + ".chunk.js";
};